import React, { useEffect, useState } from "react";
// import fries from '../../../assets/food.gif'
// import ingredient from '../../../assets/food-ingredient.gif'
// import customer from '../../../assets/customers.gif'
// import user from '../../../assets/user.gif'
import { Chart as ChartJS } from "chart.js/auto";
import { Bar, Doughnut } from "react-chartjs-2";
import { Link } from "react-router-dom";
import axios from "axios";
import { apiKey } from "../../config/config";
import Select from "react-select";
import { languageHelper } from "../../config/helperFunctions";

ChartJS.register();

function Dashboard() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const defaultLang = localStorage.getItem("rms-lang") || "text_en";
  const [pageLoading, setPageLoading] = useState(true);
  const [outlets, setOutlets] = useState([]);
  const [selectedOutlet, setSelectedOutlet] = useState(user?.user.outlet_id);

  const [itemsData, setItemsData] = useState([
    {
      title: languageHelper(defaultLang, "Items"),
      no: "123",
      img: "https://demo.imdadyrms.co/assets/dash/food.gif",
    },
    {
      title: languageHelper(defaultLang, "Ingredients"),
      no: "12",
      img: "https://demo.imdadyrms.co/assets/dash/food-ingredient.gif",
    },
    {
      title: languageHelper(defaultLang, "Customers"),
      no: "35",
      img: "https://demo.imdadyrms.co/assets/dash/customers.gif",
    },
    {
      title: languageHelper(defaultLang, "Users"),
      no: "6",
      img: "https://demo.imdadyrms.co/assets/dash/user.gif",
    },
  ]);

  const [orderTypeData] = useState([
    {
      labels: "Mahali Order",
    },
    {
      labels: "Take Away Orders",
    },
    {
      labels: "Dine In Orders",
    },
  ]);

  const [monthData, setMonthdata] = useState({
    // labels: ["Mahali", "Take Away", "Dine In"],
    datasets: [
      {
        data: [50, 50, 20],
        backgroundColor: ["purple", "#77469d", "#774d96"],
        hoverOffset: 4,
      },
    ],
  });

  const [data1, setData1] = useState({
    labels: [
      "Purchases",
      "Sales",
      "Return",
      "Expenses",
      "Waste",
      "Customer Review",
      "Supplier Payment",
    ],
    datasets: [
      {
        label: "",
        data: [0, 8, 0, 0, 0, 0, 0, 10],
        backgroundColor: "#77469d",
      },
    ],
  });

  const options = {};

  const [data2, setData2] = useState({
    labels: [
      "Mar-23",
      "Apr-23",
      "May-23",
      "Jun-23",
      "Jul-23",
      "Aug-23",
      "Sep-23",
      "Oct-23",
      "Nov-23",
      "DEc-23",
      "Jan-24",
      "Feb-24",
    ],
    datasets: [
      {
        label: "",
        data: [0, 0, 0, 0, 0, 0, 0, 3, 2, 3, 8, 1, 10],
        backgroundColor: "#77469d",
      },
    ],
  });
  const options2 = {};

  const [ingredientData] = useState([
    {
      data: "box basbousa Large(006)",
      no: "130",
    },
    {
      data: "box basbousa Small(007)",
      no: "-30",
    },
    {
      data: "Basbousah ",
      no: "0.0",
    },
  ]);

  const [saleData, setSaleData] = useState([
    {
      name: "test",
      no: "4",
    },
    {
      name: "deal 2",
      no: "3",
    },
    {
      name: "club sandwich",
      no: "3",
    },
    {
      name: "strawberry juice",
      no: "2",
    },
    {
      name: "chocolate",
      no: "0",
    },
  ]);

  const [buttonData] = useState([
    {
      name: "Items",
      path: "../foodMenus",
    },
    {
      name: "Add Ons",
      path: "../addOn",
    },
    {
      name: "Printer",
      path: "../printer",
    },
    {
      name: "Copy Items",
      path: "../copyItems",
    },
    {
      name: "Tables",
      path: "../tables",
    },
    {
      name: "Return",
      path: "../return",
    },
    {
      name: "Deposite",
      path: "../deposite",
    },
    {
      name: "Expenses",
      path: "../expenses",
    },
    {
      name: "Role Managment",
      path: "../manageUser",
    },
    {
      name: "Product Discount",
      path: "../productdiscount",
    },
    {
      name: "Category Discount",
      path: "../categorydiscount",
    },
    {
      name: "Customer",
      path: "../customer",
    },
    {
      name: "Rider Order",
      path: "../listorder",
    },
    {
      name: "Detail Shift Report",
      path: "../detailedShiftReport",
    },
    {
      name: "Expense Report",
      path: "../expensesReport",
    },
    {
      name: "Return Report",
      path: "../returnReport",
    },
  ]);

  useEffect(() => {
    const color1 = getComputedStyle(document.documentElement)
      .getPropertyValue("--color-d-bg")
      .trim();
    const color2 = getComputedStyle(document.documentElement)
      .getPropertyValue("--color-d-bg-light")
      .trim();
    const color3 = getComputedStyle(document.documentElement)
      .getPropertyValue("--color-d-bg-dark")
      .trim();

    axios
      .get(`${apiKey}/api/rms/admin/sales-summary-by-dashboard`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: selectedOutlet,
        },
      })
      .then((res) => {
        setItemsData([
          {
            title: languageHelper(defaultLang, "Items"),
            no: res.data.food_menus_count,
            img: "https://demo.imdadyrms.co/assets/dash/food.gif",
          },
          {
            title: languageHelper(defaultLang, "Ingredients"),
            no: res.data.ingredient_count,
            img: "https://demo.imdadyrms.co/assets/dash/food-ingredient.gif",
          },
          {
            title: languageHelper(defaultLang, "Customers"),
            no: res.data.customer_count,
            img: "https://demo.imdadyrms.co/assets/dash/customers.gif",
          },
          {
            title: languageHelper(defaultLang, "Users"),
            no: res.data.user_count,
            img: "https://demo.imdadyrms.co/assets/dash/user.gif",
          },
        ]);
        setData2({
          labels: res.data.monthly_sale.map((sale) => sale.month_name),
          datasets: [
            {
              label: "",
              data: res.data.monthly_sale.map((sale) => sale.total_sales),
              backgroundColor: color1,
            },
          ],
        });
        setMonthdata({
          // labels: ["Mahali", "Take Away", "Dine In"],
          datasets: [
            {
              data: res.data.order_type_sales.map((order) => order.count),
              backgroundColor: [color3, color1, color2],
              hoverOffset: 4,
            },
          ],
        });
        setSaleData(
          res.data.top_10_sale_items.map((item) => ({
            name: item.name,
            no: item.total_qty,
          }))
        );
        setData1({
          labels: [
            "Purchases",
            "Sales",
            "Return",
            "Expenses",
            "Waste",
            "Customer Review",
            "Supplier Payment",
          ],
          datasets: [
            {
              label: "",
              data: [
                0,
                res.data.current_month_sale,
                0,
                res.data.current_month_expense,
                0,
                0,
                0,
                10,
              ],
              backgroundColor: color1,
            },
          ],
        });
      })
      .catch((err) => {})
      .finally(() => {
        setPageLoading(false);
      });
  }, [user?.token, selectedOutlet, defaultLang]);

  useEffect(() => {
    if (user?.user.role === "super-admin") {
      axios
        .get(`${apiKey}/api/rms/admin/get-outlets`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          const mappedOutlets = res.data.map((outlet) => ({
            value: outlet.id,
            label: outlet.name,
          }));
          setOutlets(mappedOutlets);
        })
        .catch((err) => {});
    }
  }, [selectedOutlet, user?.token, user?.user.role]);

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }
  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-d-bg-text text-2xl">
            {languageHelper(defaultLang, "Dashboard")}
          </h1>
        </div>

        {user?.user.role === "super-admin" && (
          <div className="flex justify-end mb-6">
            <Select
              className=" placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline min-w-64"
              options={outlets}
              onChange={(e) => setSelectedOutlet(e.value)}
              placeholder="Select Outlet"
            />
          </div>
        )}

        <div className="flex">
          <div className="w-1/2 gap-4 flex flex-wrap ">
            {itemsData &&
              itemsData.map((data) => (
                <div className="w-2/5  bg-white  shadow-lg  border-l-8 border-solid border-d-bg rounded-2xl">
                  <h1 className="p-2 font-semibold">{data.title}</h1>
                  <div className="flex justify-between">
                    <h2 className="text-4xl text-d-bg-text font-bold px-2 pt-3">
                      {data.no}
                    </h2>
                    <div>
                      <img src={data.img} alt="" className="w-28   -mt-6" />
                    </div>
                  </div>
                </div>
              ))}
          </div>

          <div
            className=" w-1/2 h-auto   bg-white  shadow-lg  border-l-8
           border-solid border-d-bg rounded-2xl"
          >
            <div className="flex mb-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
                width={20}
                height={18}
                className="my-2 ms-1 fill-d-bg-text"
              >
                <path d="M304 240V16.6c0-9 7-16.6 16-16.6C443.7 0 544 100.3 544 224c0 9-7.6 16-16.6 16H304zM32 272C32 150.7 122.1 50.3 239 34.3c9.2-1.3 17 6.1 17 15.4V288L412.5 444.5c6.7 6.7 6.2 17.7-1.5 23.1C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272zm526.4 16c9.3 0 16.6 7.8 15.4 17c-7.7 55.9-34.6 105.6-73.9 142.3c-6 5.6-15.4 5.2-21.2-.7L320 288H558.4z" />
              </svg>
              <h1 className="text-xs p-2 font-bold text-d-bg-text">
                Mahali cash/Take Away/Delivery(This Month){" "}
              </h1>
              <span className="text-xs py-2 text-[#6f6b7d]">
                2024-02-01 to 2024-02-29
              </span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
                width={16}
                height={18}
                className=" ms-1 my-2 fill-d-bg-text cursor-pointer"
              >
                <path d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192h80v56H48V192zm0 104h80v64H48V296zm128 0h96v64H176V296zm144 0h80v64H320V296zm80-48H320V192h80v56zm0 160v40c0 8.8-7.2 16-16 16H320V408h80zm-128 0v56H176V408h96zm-144 0v56H64c-8.8 0-16-7.2-16-16V408h80zM272 248H176V192h96v56z" />
              </svg>
            </div>

            <div className="flex justify-between">
              <div className=" mt-2">
                {orderTypeData &&
                  orderTypeData.map((data) => (
                    <p className=" flex my-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                        width={20}
                        height={20}
                        className=" fill-d-bg-text mx-2"
                      >
                        <path d="M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM241 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239c9.4 9.4 9.4 24.6 0 33.9L241 377z" />
                      </svg>

                      <h1 className="text-lg  -mt-1 text-d-bg-text font-bold">
                        {data.labels}
                      </h1>
                    </p>
                  ))}
              </div>
              <div className="w-64">
                <Doughnut data={monthData} />
              </div>
            </div>
          </div>
        </div>

        {/* Quick-Link */}
        <div className="flex gap-2 my-7">
          <div
            className="w-2/3    bg-white  shadow-lg  border-l-8
           border-solid border-d-bg rounded-2xl my-3 mt-8"
          >
            <p className=" flex my-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
                width={25}
                height={20}
                className=" fill-d-bg-text mx-2"
              >
                <path d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z" />
              </svg>

              <h1 className="text-lg  -mt-1 text-d-bg-text font-bold">
                Quick link
              </h1>
            </p>

            <div className="flex flex-wrap gap-2 mt-5">
              {buttonData &&
                buttonData.map((index) => (
                  <Link
                    to={index.path}
                    className="text-d-bg-text bg-white border border-d-bg border-solid  rounded-xl text-center  w-36 py-1 px-1 text-sm ms-1 cursor-pointer font-semibold hover:bg-d-bg hover:text-white transition-all"
                  >
                    {index.name}
                  </Link>
                ))}
            </div>
          </div>

          <div
            className="w-1/3 bg-white  shadow-lg  border-l-8
           border-solid border-d-bg rounded-2xl my-3"
          >
            <p className=" flex my-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
                width={25}
                height={20}
                className=" fill-d-bg-text mx-2"
              >
                <path d="M416 0C400 0 288 32 288 176V288c0 35.3 28.7 64 64 64h32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352 240 32c0-17.7-14.3-32-32-32zM64 16C64 7.8 57.9 1 49.7 .1S34.2 4.6 32.4 12.5L2.1 148.8C.7 155.1 0 161.5 0 167.9c0 45.9 35.1 83.6 80 87.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V255.6c44.9-4.1 80-41.8 80-87.7c0-6.4-.7-12.8-2.1-19.1L191.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S160 7.8 160 16V150.2c0 5.4-4.4 9.8-9.8 9.8c-5.1 0-9.3-3.9-9.8-9L127.9 14.6C127.2 6.3 120.3 0 112 0s-15.2 6.3-15.9 14.6L83.7 151c-.5 5.1-4.7 9-9.8 9c-5.4 0-9.8-4.4-9.8-9.8V16zm48.3 152l-.3 0-.3 0 .3-.7 .3 .7z" />
              </svg>

              <h1 className="text-lg  -mt-1 text-d-bg-text font-bold">
                Most Sale Items This Month
              </h1>
            </p>
            <div className="bg-d-bg ms-2">
              <p className="flex justify-between text-sm font-semibold p-2 text-white">
                <h1 className="">Item Name</h1>
                <h1>Count</h1>
              </p>
            </div>
            <div className=" ms-2">
              {saleData &&
                saleData.map((index) => (
                  <p className="flex justify-between text-sm font-semibold p-2 ">
                    <h1 className="">{index.name}</h1>
                    <h1 className="">{index.no}</h1>
                  </p>
                ))}
            </div>
          </div>
        </div>

        {/* Sale-Comparison */}
        <div className="flex gap-2 my-7">
          <div className=" w-2/3   bg-white  shadow-lg  border-l-8 border-solid border-d-bg rounded-2xl my-3 ">
            <p className=" flex my-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
                width={25}
                height={20}
                className=" fill-d-bg-text mx-2"
              >
                <path d="M304 240V16.6c0-9 7-16.6 16-16.6C443.7 0 544 100.3 544 224c0 9-7.6 16-16.6 16H304zM32 272C32 150.7 122.1 50.3 239 34.3c9.2-1.3 17 6.1 17 15.4V288L412.5 444.5c6.7 6.7 6.2 17.7-1.5 23.1C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272zm526.4 16c9.3 0 16.6 7.8 15.4 17c-7.7 55.9-34.6 105.6-73.9 142.3c-6 5.6-15.4 5.2-21.2-.7L320 288H558.4z" />
              </svg>

              <h1 className="text-lg  -mt-1 text-d-bg-text font-bold">
                Monthly Sale Comparison
              </h1>
            </p>
            <Bar data={data2} options={options2} />
          </div>

          <div
            className="w-1/3  bg-white  shadow-lg  border-l-8
           border-solid border-d-bg rounded-2xl my-3"
          >
            <p className=" flex my-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
                width={25}
                height={20}
                className=" fill-d-bg-text mx-2"
              >
                <path d="M416 0C400 0 288 32 288 176V288c0 35.3 28.7 64 64 64h32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352 240 32c0-17.7-14.3-32-32-32zM64 16C64 7.8 57.9 1 49.7 .1S34.2 4.6 32.4 12.5L2.1 148.8C.7 155.1 0 161.5 0 167.9c0 45.9 35.1 83.6 80 87.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V255.6c44.9-4.1 80-41.8 80-87.7c0-6.4-.7-12.8-2.1-19.1L191.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S160 7.8 160 16V150.2c0 5.4-4.4 9.8-9.8 9.8c-5.1 0-9.3-3.9-9.8-9L127.9 14.6C127.2 6.3 120.3 0 112 0s-15.2 6.3-15.9 14.6L83.7 151c-.5 5.1-4.7 9-9.8 9c-5.4 0-9.8-4.4-9.8-9.8V16zm48.3 152l-.3 0-.3 0 .3-.7 .3 .7z" />
              </svg>

              <h1 className="text-lg  -mt-1 text-d-bg-text font-bold">
                Ingredients in Alert
              </h1>
            </p>
            <div className="bg-d-bg ms-2">
              <p className="flex justify-between text-sm font-semibold p-2 text-white">
                <h1>Ingredient Name</h1>
                <h1>Current Stock</h1>
              </p>
            </div>
            <div className="ms-2">
              {ingredientData &&
                ingredientData.map((index) => (
                  <p className="flex justify-between text-sm font-semibold p-2 ">
                    <h1>{index.data}</h1>
                    <h1>{index.no}</h1>
                  </p>
                ))}
            </div>
          </div>
        </div>

        {/* Bar-Chart */}
        <div
          className="  w-full  bg-white  shadow-lg  border-l-8
           border-solid border-d-bg rounded-2xl my-3"
        >
          <p className=" flex my-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512"
              width={25}
              height={20}
              className=" fill-d-bg-text mx-2"
            >
              <path d="M48 0C21.5 0 0 21.5 0 48V368c0 26.5 21.5 48 48 48H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H48zM416 160h50.7L544 237.3V256H416V160zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z" />
            </svg>

            <h1 className="text-lg  -mt-1 text-d-bg-text font-bold">
              Operational Comparision(This Month)
            </h1>
          </p>
          <Bar data={data1} options={options} />
        </div>
      </div>
    </main>
  );
}

export default Dashboard;
